import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { appEventConfigInitializer } from 'src/app/@configs/app-event-config.init';
import { appIconsInitializer } from 'src/app/@configs/app-icons.init';
import { appRouteTrackingInitializer } from 'src/app/@configs/app-route-tracking.init';
import { appScrollTrackingInitializer } from 'src/app/@configs/app-scroll-tracking.init';
import { authInterceptor } from 'src/app/@interceptors/auth.interceptor';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    importProvidersFrom(
      BrowserModule,
      MatIconModule,
      FormsModule,
      MatSnackBarModule
    ),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimations(),
    provideAppInitializer(() => {
      const initializerFn = appEventConfigInitializer();
      return initializerFn();
    }),
    provideAppInitializer(() => {
      const initializerFn = appIconsInitializer();
      return initializerFn();
    }),
    provideAppInitializer(() => {
      const initializerFn = appRouteTrackingInitializer();
      return initializerFn();
    }),
    provideAppInitializer(() => {
      const initializerFn = appScrollTrackingInitializer();
      return initializerFn();
    }),
    provideAnimationsAsync(),
  ],
};
